import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import sessionStorageHelper from 'utils/SessionStorageHelper';
import { sessionStorageKeys } from 'constants/sessionStorageKeys';
import { confirmAlert } from '../../common/core/notifications/ConfirmAlert';
import paths from '../../common/constants/paths';

import orderViews from './orderViews';

import './dataViewing.scss';

import { localeStrings as strings } from 'applicationConfig';

@inject('orderStore')
@observer
class DataViewing extends Component {
  constructor(props) {
    super(props);

    this.refreshData = this.refreshData.bind(this);
    this.prevOrderDataLoadInProgress = props.orderStore.orderDataLoadInProgress;
    this.state = { expiredDialogShown: false };
  }

  refreshData() {
    let values = this.props.location.state;
    if (values) {
      sessionStorageHelper.set(sessionStorageKeys.orderSearchCriteria, values);
    } else {
      values = sessionStorageHelper.get(sessionStorageKeys.orderSearchCriteria);
    }

    let isOrderView = values.datatype === "order";
    this.props.orderStore.loadData(values, isOrderView 
      ? { callbackFunction: this.showAllOrdersFilledOrCancelledAlert, params: this.props.history} : undefined);
  }

  componentWillMount() {
    if (!this.props.orderStore.viewIds.length) {
      this.refreshData();
    }
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
  }

  getRealtimeAlertText = () => {
    const { orders } = this.props.orderStore;
    if (!orders.length) return null;

    let totalRecords = 0;
    let expiredCount = 0;

    for (const order of orders) {
      for (const item of order.data) {
        totalRecords++;
        if (item.dataType !== 'realtime') expiredCount++;
      }
    }

    if (totalRecords === 0) return null;

    if (expiredCount === totalRecords) {
      return "The data you are about to see, is no longer Real-Time";
    }
    if (expiredCount > 0) {
      return "The data or some of the data you are about to see, is no longer Real-Time";
    }
    return null;
  };

  componentDidMount() {
    // Start interval here
    this.checkInterval = setInterval(() => {
      const isLoaded = !this.props.orderStore.orderDataLoadInProgress;
      const orders = this.props.orderStore.orders;
      const hasExpiredRecords = orders.some(order =>
        order.data.some(item => item.dataType !== 'realtime')
      );
      if (isLoaded && !this.state.expiredDialogShown && hasExpiredRecords) {
        this.setState({ expiredDialogShown: true });
        this.showExpiredRecordsAlert(this.props);
        clearInterval(this.checkInterval); // Stop checking after dialog is shown
      }
    }, 300);
  }

  getDisplayText(order, viewId) {
    const isTradeView = viewId === 'tradeDisplay' || viewId === 'individual';
    const isTradeAggregate = order.messageType === "TRADE_AGGREGATE";
    const isOrderClob = order.messageType === "ORDER_CLOB";
    const count = isOrderClob ? order.data.length / 5 : order.data.length;

    let typeText;
    if (isTradeView) {
      typeText = isTradeAggregate ? 'report' : 'trade';
    } else {
      typeText = 'order';
    }

    let pluralText;
    if (isTradeView) {
      pluralText = isTradeAggregate ? 'report(s)' : 'trade(s)';
    } else {
      pluralText = 'order(s)';
    }

    return `Your ${typeText} display for ${count} ${pluralText}`;
  }

  hasNonRealtimeData = () => {
    const { orders } = this.props.orderStore;
    return orders.some(order =>
      order.data.some(item => item.dataType !== 'realtime')
    );
  };

  showExpiredRecordsAlert = (props) => {
    confirmAlert({
      title: strings.dataViewing.expiredRecordsAlert.title,
      message: this.getRealtimeAlertText(),
      confirmLabel: strings.dataViewing.expiredRecordsAlert.confirmLabel,
      cancelLabel: strings.dataViewing.expiredRecordsAlert.cancelLabel,
      onConfirm: () => {
        // Handle OK: show expired records with yellow background
        if (props.onShowExpired) props.onShowExpired();
      },
      onCancel: () => {
        props.history.push(paths.dataSelect);
      },
      closeOnEsc: true,
      className: 'size-middle'
    });
  };

  showAllOrdersFilledOrCancelledAlert = (history) => {
    confirmAlert({
      title: strings.dataViewing.allOrdersFilledOrCancelledAlert.title,
      message: strings.dataViewing.allOrdersFilledOrCancelledAlert.message,
      confirmLabel: strings.dataViewing.allOrdersFilledOrCancelledAlert.confirmLabel,
      onConfirm: () => {
        history.push(paths.dataSelect);
      },
      closeOnEsc: true,
      className: 'size-middle'
    });
  };

  render() {
    const { orders, viewIds, orderDataLoadInProgress } = this.props.orderStore;

    const views = orders.map((order, index) => {
      this.isRealTime = order.data[0].dataType === 'realtime';
      const OrderView = orderViews[viewIds[index]]; // Get the specific view component for this order
      if (!OrderView) return null; // Skip if no matching view component
      const viewId = viewIds[index];
      const displayText = this.getDisplayText(order, viewId);
      return (
        <div key={index} className="order-view">
          <br/>
          <div>{displayText}</div>
          <OrderView order={order} onRefresh={this.refreshData} />
        </div>
      );
    });

    return (
      <div className="data-viewing-page">
        <div className="page-body">
          {!orderDataLoadInProgress && views}
        </div>
      </div>
    );
  }
}

export default DataViewing;


// WEBPACK FOOTER //
// ./src/containers/DataViewing/DataViewing.jsx